import React, {useContext} from 'react';

import {AppContext} from '../../../AppModule/Context';
import {withExpertHomeContext} from '../../../screens/ExpertHome/ExpertHomeContextProvider';

import ChatOwnershipComponent from '../../chatComponents/chatOwnershipComponent';
import MentorPillComponent from '../../common/genericComponents/redesign/mentorPillComponent/mentorPillComponent';
import People from '../../../assets/svgComponents/People';
import WidgetPillComponent from '../../common/genericComponents/redesign/widgetPillComponent/widgetPillComponent';

import expertHomeService from '../../../services/expertHomeService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './chatListRowPillComponent.css';

const ChatListRowPillComponent = ({
  hidePersonImage = false,
  isAccountManager = false,
  isDisabled = false,
  isGroupChatRoom = false,
  isLeadsTab = false,
  isTeamChatRoom = false,
  chatRoom = {},
  expertHomeContext = {},
  myParticipantId = '',
  myRoomExtendedMentorDto = {},
  participantsInfo = {},
  roomExtendedMentorDto = {},
  widgetDto = {},
  onMentorSelected = () => {},
  onTransitionToMentorChat = () => {},
  setGroupChatTooltipData = () => {},
}) => {
  const context = useContext(AppContext);
  const showChatOwnershipComponent =
    !isLeadsTab &&
    (isTeamChatRoom ||
      (!isGroupChatRoom &&
        expertHomeService.getIsOoniEnabledForMentor(
          widgetDto,
          roomExtendedMentorDto?.mentorDto?.mentorId,
        )));

  return (
    <div className="et-chat-list-row-pill-container">
      {expertHomeContext.showMentorPills && (
        <>
          {showChatOwnershipComponent ? (
            <div className="et-clrpc-team-chat-pill">
              {chatRoom.ownerObjectId && (
                <div className="et-clrpc-widget-pill">
                  <WidgetPillComponent
                    widgetAppCtrlDto={widgetDto?.widgetAppCtrlDto}
                    hideWidgetName={true}
                    isChatUI={true}
                  />
                </div>
              )}
              <ChatOwnershipComponent
                canChangeOwnership={
                  isTeamChatRoom
                    ? widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
                      VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
                      ? [
                          VIDABOO_CONSTANTS.WIDGET_ADMIN_ROLES.ADMIN,
                          VIDABOO_CONSTANTS.WIDGET_ADMIN_ROLES.READ_PRIVATE,
                        ].includes(myRoomExtendedMentorDto?.widgetRole)
                      : true
                    : true
                }
                isDisabled={isDisabled}
                isTeamChatRoom={isTeamChatRoom}
                chatRoom={chatRoom}
                showTransitionToMentorChatBtn={
                  isTeamChatRoom &&
                  chatRoom.taskOwnerMentorId === myParticipantId &&
                  widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode !==
                    VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
                }
                taskOwnerMentorId={chatRoom.taskOwnerMentorId}
                roomOwnerObjectId={chatRoom.ownerObjectId}
                onMentorSelected={onMentorSelected}
                onTransitionToMentorChat={onTransitionToMentorChat}
              />
            </div>
          ) : (
            roomExtendedMentorDto &&
            roomExtendedMentorDto.mentorDto && (
              <div
                className={isGroupChatRoom ? 'et-clrpc-group-chat-pill' : ''}>
                <div className="et-clrpc-widget-pill">
                  <WidgetPillComponent
                    widgetAppCtrlDto={widgetDto?.widgetAppCtrlDto}
                    hideWidgetName={true}
                    isChatUI={true}
                  />
                </div>
                <MentorPillComponent
                  isChatUI
                  extendedMentorDto={roomExtendedMentorDto}
                  customToolTipTxt={
                    isGroupChatRoom
                      ? null
                      : `One-on-one conversation \n Widget: ${widgetDto?.widgetAppCtrlDto?.name} \n Display name: ${roomExtendedMentorDto.mentorDto.displayName} \n Email: ${
                          isAccountManager
                            ? roomExtendedMentorDto.email
                            : context.getCurrentUser().email
                        }  \n Handle: ${
                          roomExtendedMentorDto.mentorDto.profileName
                        }`
                  }
                  widgetName={widgetDto.widgetAppCtrlDto.name}
                />
              </div>
            )
          )}
          {!hidePersonImage && (
            <div>
              <div className="et-clrpc-arrow" />
            </div>
          )}
        </>
      )}
      {!hidePersonImage && (
        <div
          className="et-clrpc-img-participant-count-wrap"
          onMouseEnter={(e) => {
            if (isGroupChatRoom) {
              const {top, left} = e.target.getBoundingClientRect();
              setGroupChatTooltipData({
                style: {top: top - 62, left: left + 20},
                chatRoom,
              });
            }
          }}
          onMouseLeave={() => {
            if (isGroupChatRoom) {
              setGroupChatTooltipData(null);
            }
          }}>
          {isGroupChatRoom && (
            <div className="et-clrpc-participants-count-txt">
              {Object.keys(participantsInfo)?.length}
            </div>
          )}
          <People peopleCount={isGroupChatRoom ? 2 : 1} />
        </div>
      )}
    </div>
  );
};

export default withExpertHomeContext(ChatListRowPillComponent);
